module.exports = __webpack_public_path__ + "63924ae61b085a7477bcc9f397b7e628.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/spotify.png
// module id = ./assets/thumbnails/spotify.png
// module chunks = 2